import { BlockDefinition } from '../../../types/pageBuilder';

const svgIcon = `<svg viewBox="0 0 24 24" fill="currentColor"><path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"/></svg>`;

const formIcon = `<svg viewBox="0 0 24 24" fill="currentColor"><path d="M20 2H4a2 2 0 00-2 2v16a2 2 0 002 2h16a2 2 0 002-2V4a2 2 0 00-2-2zM7 7h10v2H7V7zm0 4h10v2H7v-2zm0 4h6v2H7v-2z"/></svg>`;

/**
 * Formulário DevSkin em formato de CARD — cabe dentro da coluna de um hero,
 * de um card ou de qualquer div (os outros blocos de formulário são seções
 * inteiras e não encaixam ao lado de um texto).
 *
 * É o substituto direto de formulários do RD Station/HubSpot, que só renderizam
 * com o script do provedor e chegam vazios na página publicada. Os leads caem
 * no CRM/fluxo pelo runtime da DevSkin (name/email/phone são os campos padrão).
 */
export const LEAD_FORM_CARD_HTML = `
      <form class="dsk-form-card" data-success-message="Inscrição confirmada! Você vai receber os detalhes por e-mail." style="background:#ffffff;padding:28px;border-radius:16px;box-shadow:0 12px 34px rgba(0,0,0,0.12);width:100%;max-width:440px;box-sizing:border-box;text-align:left;">
        <h3 style="margin:0 0 8px;font-size:1.4rem;font-weight:700;color:#111827;">Inscreva-se gratuitamente</h3>
        <p style="margin:0 0 20px;font-size:0.95rem;color:#6b7280;line-height:1.5;">Preencha seus dados e garanta a sua vaga.</p>
        <div style="margin-bottom:14px;">
          <label style="display:block;font-size:0.85rem;font-weight:600;color:#374151;margin-bottom:6px;">Nome completo *</label>
          <input type="text" name="name" placeholder="Seu nome" required style="width:100%;padding:13px 14px;border:1px solid #d1d5db;border-radius:10px;font-size:1rem;box-sizing:border-box;background:#fff;color:#111827;">
        </div>
        <div style="margin-bottom:14px;">
          <label style="display:block;font-size:0.85rem;font-weight:600;color:#374151;margin-bottom:6px;">E-mail *</label>
          <input type="email" name="email" placeholder="voce@email.com" required style="width:100%;padding:13px 14px;border:1px solid #d1d5db;border-radius:10px;font-size:1rem;box-sizing:border-box;background:#fff;color:#111827;">
        </div>
        <div style="margin-bottom:20px;">
          <label style="display:block;font-size:0.85rem;font-weight:600;color:#374151;margin-bottom:6px;">WhatsApp *</label>
          <input type="tel" name="phone" placeholder="(11) 99999-9999" required style="width:100%;padding:13px 14px;border:1px solid #d1d5db;border-radius:10px;font-size:1rem;box-sizing:border-box;background:#fff;color:#111827;">
        </div>
        <button type="submit" style="width:100%;padding:15px;background:#111827;color:#ffffff;font-weight:700;font-size:1rem;border:none;border-radius:10px;cursor:pointer;">
          QUERO GARANTIR MINHA VAGA
        </button>
        <p style="margin:14px 0 0;font-size:0.75rem;color:#9ca3af;text-align:center;line-height:1.4;">Seus dados estão seguros e não serão compartilhados.</p>
      </form>
`;

export const conversionBlocks: BlockDefinition[] = [
  {
    id: 'lead-form-card',
    // Fica na mesma categoria FORMULARIOS onde o cliente procura por formulário.
    label: 'Formulário (card) - cabe no hero',
    category: 'Formulários',
    media: formIcon,
    content: LEAD_FORM_CARD_HTML,
    attributes: { class: 'gjs-block-form' }
  },
  {
    id: 'cta-simple',
    label: 'CTA Simples',
    category: 'Conversao',
    media: svgIcon,
    content: `
      <section class="cta-section" style="padding: 100px 20px; background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%); text-align: center;">
        <div style="max-width: 700px; margin: 0 auto;">
          <h2 style="font-size: 2.5rem; font-weight: 700; color: white; margin-bottom: 16px;">
            Pronto para comecar?
          </h2>
          <p style="font-size: 1.25rem; color: rgba(255,255,255,0.9); margin-bottom: 32px;">
            Junte-se a milhares de empresas que ja transformaram seus resultados.
          </p>
          <div style="display: flex; gap: 16px; justify-content: center; flex-wrap: wrap;">
            <a href="#" style="display: inline-block; padding: 16px 40px; background-color: white; color: #6366f1; font-weight: 600; font-size: 1rem; border-radius: 8px; text-decoration: none;">
              Comecar Gratis
            </a>
            <a href="#" style="display: inline-block; padding: 16px 40px; background-color: transparent; color: white; font-weight: 600; font-size: 1rem; border: 2px solid rgba(255,255,255,0.5); border-radius: 8px; text-decoration: none;">
              Falar com Vendas
            </a>
          </div>
        </div>
      </section>
    `,
    attributes: { class: 'gjs-block-cta' }
  },
  {
    id: 'cta-countdown',
    label: 'CTA com Urgencia',
    category: 'Conversao',
    media: svgIcon,
    content: `
      <section class="cta-urgency" style="padding: 80px 20px; background: linear-gradient(135deg, #dc2626 0%, #f97316 100%); text-align: center;">
        <div style="max-width: 800px; margin: 0 auto;">
          <span style="display: inline-block; padding: 8px 20px; background: rgba(255,255,255,0.2); color: white; font-weight: 600; border-radius: 9999px; margin-bottom: 24px; font-size: 0.875rem; text-transform: uppercase; letter-spacing: 0.1em;">
            Oferta por tempo limitado
          </span>
          <h2 style="font-size: 3rem; font-weight: 800; color: white; margin-bottom: 16px;">
            50% de desconto so ate meia-noite!
          </h2>
          <p style="font-size: 1.25rem; color: rgba(255,255,255,0.9); margin-bottom: 32px;">
            Nao perca essa oportunidade unica. Aproveite agora!
          </p>
          <div style="display: flex; gap: 16px; justify-content: center; margin-bottom: 32px;">
            <div style="background: rgba(0,0,0,0.2); padding: 16px 24px; border-radius: 12px; min-width: 80px;">
              <p style="font-size: 2.5rem; font-weight: 800; color: white; margin: 0;">12</p>
              <p style="font-size: 0.75rem; color: rgba(255,255,255,0.7); text-transform: uppercase;">Horas</p>
            </div>
            <div style="background: rgba(0,0,0,0.2); padding: 16px 24px; border-radius: 12px; min-width: 80px;">
              <p style="font-size: 2.5rem; font-weight: 800; color: white; margin: 0;">34</p>
              <p style="font-size: 0.75rem; color: rgba(255,255,255,0.7); text-transform: uppercase;">Minutos</p>
            </div>
            <div style="background: rgba(0,0,0,0.2); padding: 16px 24px; border-radius: 12px; min-width: 80px;">
              <p style="font-size: 2.5rem; font-weight: 800; color: white; margin: 0;">56</p>
              <p style="font-size: 0.75rem; color: rgba(255,255,255,0.7); text-transform: uppercase;">Segundos</p>
            </div>
          </div>
          <a href="#" style="display: inline-block; padding: 20px 48px; background-color: white; color: #dc2626; font-weight: 700; font-size: 1.125rem; border-radius: 8px; text-decoration: none; box-shadow: 0 10px 40px -10px rgba(0,0,0,0.3);">
            Garantir Meu Desconto
          </a>
        </div>
      </section>
    `,
    attributes: { class: 'gjs-block-cta' }
  },
  {
    id: 'pricing-table',
    label: 'Tabela de Precos',
    category: 'Conversao',
    media: svgIcon,
    content: `
      <section class="pricing-section" style="padding: 100px 20px; background-color: #f9fafb;">
        <div style="max-width: 1200px; margin: 0 auto;">
          <div style="text-align: center; margin-bottom: 60px;">
            <h2 style="font-size: 2.5rem; font-weight: 700; color: #111827; margin-bottom: 16px;">
              Planos e Precos
            </h2>
            <p style="font-size: 1.125rem; color: #6b7280;">
              Escolha o plano ideal para o seu negocio
            </p>
          </div>
          <div style="display: grid; grid-template-columns: repeat(3, 1fr); gap: 32px; align-items: start;">
            <!-- Starter -->
            <div style="background: white; padding: 40px 32px; border-radius: 20px; box-shadow: 0 1px 3px rgba(0,0,0,0.1);">
              <h3 style="font-size: 1.5rem; font-weight: 600; color: #111827; margin-bottom: 8px;">Starter</h3>
              <p style="color: #6b7280; margin-bottom: 24px;">Para quem esta comecando</p>
              <div style="margin-bottom: 32px;">
                <span style="font-size: 3rem; font-weight: 800; color: #111827;">R$49</span>
                <span style="color: #6b7280;">/mes</span>
              </div>
              <ul style="list-style: none; padding: 0; margin: 0 0 32px 0;">
                <li style="display: flex; align-items: center; gap: 12px; padding: 12px 0; border-bottom: 1px solid #f3f4f6;">
                  <svg width="20" height="20" fill="#10b981" viewBox="0 0 24 24"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z"/></svg>
                  <span style="color: #4b5563;">Ate 5 usuarios</span>
                </li>
                <li style="display: flex; align-items: center; gap: 12px; padding: 12px 0; border-bottom: 1px solid #f3f4f6;">
                  <svg width="20" height="20" fill="#10b981" viewBox="0 0 24 24"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z"/></svg>
                  <span style="color: #4b5563;">10GB de storage</span>
                </li>
                <li style="display: flex; align-items: center; gap: 12px; padding: 12px 0; border-bottom: 1px solid #f3f4f6;">
                  <svg width="20" height="20" fill="#10b981" viewBox="0 0 24 24"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z"/></svg>
                  <span style="color: #4b5563;">Suporte por email</span>
                </li>
                <li style="display: flex; align-items: center; gap: 12px; padding: 12px 0;">
                  <svg width="20" height="20" fill="#10b981" viewBox="0 0 24 24"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z"/></svg>
                  <span style="color: #4b5563;">Relatorios basicos</span>
                </li>
              </ul>
              <a href="#" style="display: block; text-align: center; padding: 14px; background-color: #f3f4f6; color: #111827; font-weight: 600; border-radius: 8px; text-decoration: none;">
                Comecar Agora
              </a>
            </div>
            <!-- Pro (destaque) -->
            <div style="background: linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%); padding: 40px 32px; border-radius: 20px; box-shadow: 0 25px 50px -12px rgba(79, 70, 229, 0.4); transform: scale(1.05);">
              <div style="display: flex; justify-content: space-between; align-items: start; margin-bottom: 8px;">
                <h3 style="font-size: 1.5rem; font-weight: 600; color: white;">Pro</h3>
                <span style="padding: 4px 12px; background: rgba(255,255,255,0.2); color: white; font-size: 0.75rem; font-weight: 600; border-radius: 9999px;">Popular</span>
              </div>
              <p style="color: rgba(255,255,255,0.8); margin-bottom: 24px;">Para equipes em crescimento</p>
              <div style="margin-bottom: 32px;">
                <span style="font-size: 3rem; font-weight: 800; color: white;">R$99</span>
                <span style="color: rgba(255,255,255,0.8);">/mes</span>
              </div>
              <ul style="list-style: none; padding: 0; margin: 0 0 32px 0;">
                <li style="display: flex; align-items: center; gap: 12px; padding: 12px 0; border-bottom: 1px solid rgba(255,255,255,0.2);">
                  <svg width="20" height="20" fill="white" viewBox="0 0 24 24"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z"/></svg>
                  <span style="color: white;">Ate 25 usuarios</span>
                </li>
                <li style="display: flex; align-items: center; gap: 12px; padding: 12px 0; border-bottom: 1px solid rgba(255,255,255,0.2);">
                  <svg width="20" height="20" fill="white" viewBox="0 0 24 24"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z"/></svg>
                  <span style="color: white;">100GB de storage</span>
                </li>
                <li style="display: flex; align-items: center; gap: 12px; padding: 12px 0; border-bottom: 1px solid rgba(255,255,255,0.2);">
                  <svg width="20" height="20" fill="white" viewBox="0 0 24 24"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z"/></svg>
                  <span style="color: white;">Suporte prioritario</span>
                </li>
                <li style="display: flex; align-items: center; gap: 12px; padding: 12px 0;">
                  <svg width="20" height="20" fill="white" viewBox="0 0 24 24"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z"/></svg>
                  <span style="color: white;">API Access</span>
                </li>
              </ul>
              <a href="#" style="display: block; text-align: center; padding: 14px; background-color: white; color: #4f46e5; font-weight: 600; border-radius: 8px; text-decoration: none;">
                Comecar Agora
              </a>
            </div>
            <!-- Enterprise -->
            <div style="background: white; padding: 40px 32px; border-radius: 20px; box-shadow: 0 1px 3px rgba(0,0,0,0.1);">
              <h3 style="font-size: 1.5rem; font-weight: 600; color: #111827; margin-bottom: 8px;">Enterprise</h3>
              <p style="color: #6b7280; margin-bottom: 24px;">Para grandes empresas</p>
              <div style="margin-bottom: 32px;">
                <span style="font-size: 3rem; font-weight: 800; color: #111827;">R$249</span>
                <span style="color: #6b7280;">/mes</span>
              </div>
              <ul style="list-style: none; padding: 0; margin: 0 0 32px 0;">
                <li style="display: flex; align-items: center; gap: 12px; padding: 12px 0; border-bottom: 1px solid #f3f4f6;">
                  <svg width="20" height="20" fill="#10b981" viewBox="0 0 24 24"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z"/></svg>
                  <span style="color: #4b5563;">Usuarios ilimitados</span>
                </li>
                <li style="display: flex; align-items: center; gap: 12px; padding: 12px 0; border-bottom: 1px solid #f3f4f6;">
                  <svg width="20" height="20" fill="#10b981" viewBox="0 0 24 24"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z"/></svg>
                  <span style="color: #4b5563;">Storage ilimitado</span>
                </li>
                <li style="display: flex; align-items: center; gap: 12px; padding: 12px 0; border-bottom: 1px solid #f3f4f6;">
                  <svg width="20" height="20" fill="#10b981" viewBox="0 0 24 24"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z"/></svg>
                  <span style="color: #4b5563;">Suporte 24/7</span>
                </li>
                <li style="display: flex; align-items: center; gap: 12px; padding: 12px 0;">
                  <svg width="20" height="20" fill="#10b981" viewBox="0 0 24 24"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z"/></svg>
                  <span style="color: #4b5563;">Integracoes custom</span>
                </li>
              </ul>
              <a href="#" style="display: block; text-align: center; padding: 14px; background-color: #f3f4f6; color: #111827; font-weight: 600; border-radius: 8px; text-decoration: none;">
                Falar com Vendas
              </a>
            </div>
          </div>
        </div>
      </section>
    `,
    attributes: { class: 'gjs-block-pricing' }
  },
  {
    id: 'lead-form',
    label: 'Formulario de Lead',
    category: 'Conversao',
    media: svgIcon,
    content: `
      <section class="form-section" style="padding: 100px 20px; background-color: #ffffff;">
        <div style="max-width: 600px; margin: 0 auto;">
          <div style="text-align: center; margin-bottom: 40px;">
            <h2 style="font-size: 2rem; font-weight: 700; color: #111827; margin-bottom: 12px;">
              Solicite uma demonstracao
            </h2>
            <p style="color: #6b7280;">
              Preencha o formulario e entraremos em contato em ate 24h
            </p>
          </div>
          <form data-success-message="Obrigado! Entraremos em contato em breve." style="background: #f9fafb; padding: 40px; border-radius: 16px;">
            <div style="margin-bottom: 20px;">
              <label style="display: block; font-weight: 500; color: #374151; margin-bottom: 8px;">Nome completo *</label>
              <input type="text" name="name" placeholder="Seu nome" required style="width: 100%; padding: 14px 16px; border: 1px solid #d1d5db; border-radius: 8px; font-size: 1rem; box-sizing: border-box;">
            </div>
            <div style="margin-bottom: 20px;">
              <label style="display: block; font-weight: 500; color: #374151; margin-bottom: 8px;">E-mail corporativo *</label>
              <input type="email" name="email" placeholder="seu@empresa.com" required style="width: 100%; padding: 14px 16px; border: 1px solid #d1d5db; border-radius: 8px; font-size: 1rem; box-sizing: border-box;">
            </div>
            <div style="margin-bottom: 20px;">
              <label style="display: block; font-weight: 500; color: #374151; margin-bottom: 8px;">Telefone/WhatsApp</label>
              <input type="tel" name="phone" placeholder="(11) 99999-9999" style="width: 100%; padding: 14px 16px; border: 1px solid #d1d5db; border-radius: 8px; font-size: 1rem; box-sizing: border-box;">
            </div>
            <div style="margin-bottom: 20px;">
              <label style="display: block; font-weight: 500; color: #374151; margin-bottom: 8px;">Empresa</label>
              <input type="text" name="company" placeholder="Nome da empresa" style="width: 100%; padding: 14px 16px; border: 1px solid #d1d5db; border-radius: 8px; font-size: 1rem; box-sizing: border-box;">
            </div>
            <div style="margin-bottom: 24px;">
              <label style="display: block; font-weight: 500; color: #374151; margin-bottom: 8px;">Mensagem (opcional)</label>
              <textarea name="message" placeholder="Como podemos ajudar?" rows="4" style="width: 100%; padding: 14px 16px; border: 1px solid #d1d5db; border-radius: 8px; font-size: 1rem; resize: vertical; box-sizing: border-box;"></textarea>
            </div>
            <button type="submit" style="width: 100%; padding: 16px; background: linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%); color: white; font-weight: 600; font-size: 1rem; border: none; border-radius: 8px; cursor: pointer;">
              Solicitar Demonstracao
            </button>
            <p style="text-align: center; margin-top: 16px; font-size: 0.875rem; color: #6b7280;">
              Ao enviar, voce concorda com nossa <a href="#" style="color: #4f46e5; text-decoration: underline;">Politica de Privacidade</a>
            </p>
          </form>
        </div>
      </section>
    `,
    attributes: { class: 'gjs-block-form' }
  },
  {
    id: 'newsletter-inline',
    label: 'Newsletter Inline',
    category: 'Conversao',
    media: svgIcon,
    content: `
      <section class="newsletter-section" style="padding: 60px 20px; background-color: #1e1b4b;">
        <div style="max-width: 700px; margin: 0 auto; text-align: center;">
          <h2 style="font-size: 1.75rem; font-weight: 700; color: white; margin-bottom: 12px;">
            Receba nossas novidades
          </h2>
          <p style="color: #a5b4fc; margin-bottom: 24px;">
            Assine nossa newsletter e fique por dentro das ultimas tendencias
          </p>
          <form data-success-message="Inscricao realizada com sucesso!" style="display: flex; gap: 12px; max-width: 500px; margin: 0 auto;">
            <input type="email" name="email" placeholder="Seu melhor e-mail" required style="flex: 1; padding: 14px 20px; border: none; border-radius: 8px; font-size: 1rem; background: white;">
            <button type="submit" style="padding: 14px 28px; background: linear-gradient(135deg, #8b5cf6 0%, #d946ef 100%); color: white; font-weight: 600; border: none; border-radius: 8px; cursor: pointer; white-space: nowrap;">
              Inscrever-se
            </button>
          </form>
          <p style="margin-top: 16px; font-size: 0.875rem; color: #a5b4fc;">
            Prometemos nao enviar spam. Cancele quando quiser.
          </p>
        </div>
      </section>
    `,
    attributes: { class: 'gjs-block-form' }
  },
  {
    id: 'footer-simple',
    label: 'Footer Simples',
    category: 'Conversao',
    media: svgIcon,
    content: `
      <footer style="padding: 60px 20px 30px; background-color: #111827;">
        <div style="max-width: 1200px; margin: 0 auto;">
          <div style="display: flex; justify-content: space-between; align-items: start; flex-wrap: wrap; gap: 40px; margin-bottom: 40px;">
            <div style="max-width: 300px;">
              <h3 style="font-size: 1.5rem; font-weight: 700; color: white; margin-bottom: 16px;">SuaMarca</h3>
              <p style="color: #9ca3af; line-height: 1.6; margin-bottom: 20px;">
                Transformando negocios atraves da tecnologia desde 2020.
              </p>
              <div style="display: flex; gap: 12px;">
                <a href="#" style="width: 40px; height: 40px; background: #374151; border-radius: 8px; display: flex; align-items: center; justify-content: center; color: white; text-decoration: none;">
                  <svg width="20" height="20" fill="currentColor" viewBox="0 0 24 24"><path d="M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-3.179 0-5.515 2.966-4.797 6.045-4.091-.205-7.719-2.165-10.148-5.144-1.29 2.213-.669 5.108 1.523 6.574-.806-.026-1.566-.247-2.229-.616-.054 2.281 1.581 4.415 3.949 4.89-.693.188-1.452.232-2.224.084.626 1.956 2.444 3.379 4.6 3.419-2.07 1.623-4.678 2.348-7.29 2.04 2.179 1.397 4.768 2.212 7.548 2.212 9.142 0 14.307-7.721 13.995-14.646.962-.695 1.797-1.562 2.457-2.549z"/></svg>
                </a>
                <a href="#" style="width: 40px; height: 40px; background: #374151; border-radius: 8px; display: flex; align-items: center; justify-content: center; color: white; text-decoration: none;">
                  <svg width="20" height="20" fill="currentColor" viewBox="0 0 24 24"><path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/></svg>
                </a>
                <a href="#" style="width: 40px; height: 40px; background: #374151; border-radius: 8px; display: flex; align-items: center; justify-content: center; color: white; text-decoration: none;">
                  <svg width="20" height="20" fill="currentColor" viewBox="0 0 24 24"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/></svg>
                </a>
              </div>
            </div>
            <div>
              <h4 style="font-weight: 600; color: white; margin-bottom: 16px;">Produto</h4>
              <ul style="list-style: none; padding: 0; margin: 0;">
                <li style="margin-bottom: 12px;"><a href="#" style="color: #9ca3af; text-decoration: none;">Recursos</a></li>
                <li style="margin-bottom: 12px;"><a href="#" style="color: #9ca3af; text-decoration: none;">Precos</a></li>
                <li style="margin-bottom: 12px;"><a href="#" style="color: #9ca3af; text-decoration: none;">Integracoes</a></li>
                <li><a href="#" style="color: #9ca3af; text-decoration: none;">Changelog</a></li>
              </ul>
            </div>
            <div>
              <h4 style="font-weight: 600; color: white; margin-bottom: 16px;">Empresa</h4>
              <ul style="list-style: none; padding: 0; margin: 0;">
                <li style="margin-bottom: 12px;"><a href="#" style="color: #9ca3af; text-decoration: none;">Sobre</a></li>
                <li style="margin-bottom: 12px;"><a href="#" style="color: #9ca3af; text-decoration: none;">Blog</a></li>
                <li style="margin-bottom: 12px;"><a href="#" style="color: #9ca3af; text-decoration: none;">Carreiras</a></li>
                <li><a href="#" style="color: #9ca3af; text-decoration: none;">Contato</a></li>
              </ul>
            </div>
            <div>
              <h4 style="font-weight: 600; color: white; margin-bottom: 16px;">Suporte</h4>
              <ul style="list-style: none; padding: 0; margin: 0;">
                <li style="margin-bottom: 12px;"><a href="#" style="color: #9ca3af; text-decoration: none;">Central de Ajuda</a></li>
                <li style="margin-bottom: 12px;"><a href="#" style="color: #9ca3af; text-decoration: none;">Documentacao</a></li>
                <li style="margin-bottom: 12px;"><a href="#" style="color: #9ca3af; text-decoration: none;">Status</a></li>
                <li><a href="#" style="color: #9ca3af; text-decoration: none;">API</a></li>
              </ul>
            </div>
          </div>
          <div style="border-top: 1px solid #374151; padding-top: 30px; display: flex; justify-content: space-between; align-items: center; flex-wrap: wrap; gap: 16px;">
            <p style="color: #6b7280; font-size: 0.875rem;">
              2025 SuaMarca. Todos os direitos reservados.
            </p>
            <div style="display: flex; gap: 24px;">
              <a href="#" style="color: #6b7280; font-size: 0.875rem; text-decoration: none;">Privacidade</a>
              <a href="#" style="color: #6b7280; font-size: 0.875rem; text-decoration: none;">Termos</a>
              <a href="#" style="color: #6b7280; font-size: 0.875rem; text-decoration: none;">Cookies</a>
            </div>
          </div>
        </div>
      </footer>
    `,
    attributes: { class: 'gjs-block-footer' }
  }
];
